import { DateTime } from 'luxon';

// We're MDT now, so -0600
export const saleConfig = {
  earlyAccess       : null, // Early Access
  saleStart         : DateTime.fromISO('2026-01-15T00:01:00-06:00'), // General
  lastChance        : null, // Last Chance at General
  surpriseExtension : null, // Surprise extension starts
  lastDay           : DateTime.fromISO('2026-01-27T00:00:00-06:00'), // Last day, hurry
  saleEnd           : DateTime.fromISO('2026-01-27T23:59:59-06:00'), // End
  code              : ''
};

export const saleStages = {
  EARLY_ACCESS: 'earlyAccess',
  REGULAR: 'regular',
  LAST_CHANCE: 'lastChance',
  SURPRISE_EXTENSION: 'surpriseExtension',
  LAST_DAY: 'lastDay'
}

export function calculateStage(date, config = saleConfig) {
  const {
    earlyAccess,
    saleStart,
    lastChance,
    surpriseExtension,
    lastDay,
    saleEnd
  } = config;

  if (
    earlyAccess &&
    date >= earlyAccess &&
    date < (saleStart || lastChance || surpriseExtension || lastDay || saleEnd)
  ) {
    return saleStages.EARLY_ACCESS;
  }

  if (date >= saleStart && date < (lastChance || surpriseExtension || lastDay || saleEnd)) {
    return saleStages.REGULAR;
  }

  if (lastChance && date >= lastChance && date < (surpriseExtension || lastDay || saleEnd)) {
    return saleStages.LAST_CHANCE;
  }

  if (surpriseExtension && date >= surpriseExtension && date < (lastDay || saleEnd)) {
    return saleStages.SURPRISE_EXTENSION;
  }

  if (lastDay && date >= lastDay && date < saleEnd) {
    return saleStages.LAST_DAY;
  }

  return null;
}

export function saleEndForStage(stage, config = saleConfig) {
  const { lastChance, surpriseExtension, lastDay, saleEnd } = config;
  switch (stage) {
    case saleStages.REGULAR:
      return (lastChance && lastChance.minus({minute: 1}))
        || (surpriseExtension && surpriseExtension.minus({minute: 1}))
        || (lastDay && lastDay.minus({minute: 1}))
        || saleEnd;
    case saleStages.LAST_CHANCE:
      return surpriseExtension && surpriseExtension.minus({minute: 1})
        || saleEnd;
    case saleStages.SURPRISE_EXTENSION:
      return saleEnd;
    case saleStages.LAST_DAY:
      return saleEnd;
  }

}
